export const CONTENT_TYPE_GET_REQUEST = 'app/media/CONTENT_TYPE_GET_REQUEST';
export const CONTENT_TYPE_GET_SUCCESS = 'app/media/CONTENT_TYPE_GET_SUCCESS';
export const CONTENT_TYPE_GET_FAILURE = 'app/media/CONTENT_TYPE_GET_FAILURE';
